
import state from './moduleAsetState.js'
import mutations from './moduleAsetMutations.js'
import actions from './moduleAsetActions.js'
import getters from './moduleAsetGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
